module.exports = __webpack_public_path__ + "media/images/icon__minus@2x-1df03e9f1b1e8d06ce0cdf040182baec.png";